import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
import moment from 'moment'
const model = (payload) => ({
  // columns
  id: payload.id,
  compaq: payload.compaq,
  portal_date: moment(payload.portal_date).format('YYYY-MM-DD'),
  signature: payload.signature,
  comments: payload.comments
})
var crud = new Crud('Invoices', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  invoices: [],
  invoice: {},
  payments: [],
  invoicedProducts: [],
  isModalInvoicePaymentsVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_RECORD (state, payload) {
    state.invoice = payload.data
  },
  SET_PAYMENTS (state, payload) {
    state.payments = payload.data
  },
  SET_MODAL_INVOICE_PAYMENTS_VISIBLE (state, payload) {
    state.isModalInvoicePaymentsVisible = payload
  },
  SET_INVOICED_PRODUCTS (state, payload) {
    state.invoicedProducts = payload
  }
}

const actions = {
  ...crud.actions,
  async loadPayments ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`payments/?page=${payload.page}&invoice_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PAYMENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalInvoicePaymentsVisible ({ commit }, payload) {
    commit('SET_MODAL_INVOICE_PAYMENTS_VISIBLE', payload)
  },
  async addPayment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`payments`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletePayment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`payments/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RECORD', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payment', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async refreshInvoice ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`invoices/${payload.id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        return response.data.data
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadInvoicedProducts ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`/invoiced-products/by-invoice/${payload.id}?page=${payload.page}&id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_INVOICED_PRODUCTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  invoices: state => state.invoices,
  invoice: state => state.invoice,
  payments: state => state.payments,
  invoicedProducts: state => state.invoicedProducts,
  isModalInvoicePaymentsVisible: state => state.isModalInvoicePaymentsVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
